import { render } from "./LoadingIcon.vue?vue&type=template&id=59dc3e12&scoped=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=js"
export * from "./LoadingIcon.vue?vue&type=script&lang=js"

import "./LoadingIcon.vue?vue&type=style&index=0&id=59dc3e12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59dc3e12"

export default script